import { render, staticRenderFns } from "./customTextareaWhite.vue?vue&type=template&id=9399d5a8&scoped=true"
import script from "./customTextareaWhite.vue?vue&type=script&lang=js"
export * from "./customTextareaWhite.vue?vue&type=script&lang=js"
import style0 from "./customTextareaWhite.vue?vue&type=style&index=0&id=9399d5a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9399d5a8",
  null
  
)

export default component.exports